import Vue from 'vue'
import VueRouter from 'vue-router'
import Admin from "../component/admin.vue";
import SignIn from "../component/sign-in-form.vue";
import Register from "../component/register.vue";
import Demo from "../component/demo.vue";
import Auth from "../component/auth.vue";
import ResettPwdEmail from "../component/reset-pwd-email.vue";
import ResetPwd from "../component/reset-password.vue";
import Activate from "../component/activate.vue";
import ActivateThanks from "../component/activate-thanks.vue";
import ForgetPwd from "../component/forget-pwd.vue";

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            path: "/",
            name: "admin",
            component: Admin,
            meta: { requiresAuth: true }
        },
        {
            path: "/sign-in",
            name: "sign-in",
            component: SignIn,
        },
        {
            path: "/register",
            name: "register",
            component: Register,
        },
        {
            path: "/demo",
            name: "demo",
            component: Demo,
        },
        {
            path: "/auth",
            name: "auth",
            component: Auth,
        },
        {
            path: "/reset-pwd-email",
            name: "reset-pwd-email",
            component: ResettPwdEmail,
        },
        {
            path: "/reset-pwd",
            name: "reset-pwd",
            component: ResetPwd,
        },
        {
            path: "/activate",
            name: "activate",
            component: Activate,
            meta: { requiresAuth: true }
        },
        {
            path: "/activate-thanks",
            name: "activate-thanks",
            component: ActivateThanks,
        },
        {
            path: "/forget-pwd",
            name: "forget-pwd",
            component: ForgetPwd,
        },
    ]
});

// router.beforeEach((to, from, next) => {
//     if (to.meta.requiresAuth) {
//         next({
//             name: "sign-in"
//         });
//     }
//     next();
// });
export default router;